import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import React from "react";

export const SortableItem = ({ row, render }: any) => {
  const { attributes, listeners, setNodeRef, transform, transition } =
    useSortable({ id: row._id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  };

  return render(row, {
    ref: setNodeRef,
    style,
    listeners,
    attributes,
  });
};
